import React from "react";
import { useLocation } from "react-router-dom";
import RebecaMiguelChatbot from "./RebecaMiguelChatbot";
import { REBECA_ALLOWED_ROUTES, REBECA_BLOCKED_ROUTES } from "../../data/workforceOsTools";

/**
 * Mounts the floating Rebeca chatbot on allowed routes only.
 *
 * - Skips ShiftBridge (PRN marketplace) and authenticated dashboard routes
 *   via REBECA_BLOCKED_ROUTES.
 * - Skips /workforce-os/ai-nurse-recruiter because that page already renders
 *   the embedded variant. All other allowlisted pages (homepage, /clinicians,
 *   /careers, /careers/jobs, /register, /workforce-os, other Workforce OS
 *   tools, /compliance/checklists/*) get the floating launcher.
 */
const PAGES_WITH_EMBEDDED_INSTANCE = [
  /^\/workforce-os\/ai-nurse-recruiter\/?$/,
];

export default function RebecaFloatingMount() {
  const { pathname } = useLocation();
  if (REBECA_BLOCKED_ROUTES.some((re) => re.test(pathname))) return null;
  if (PAGES_WITH_EMBEDDED_INSTANCE.some((re) => re.test(pathname))) return null;
  if (!REBECA_ALLOWED_ROUTES.some((re) => re.test(pathname))) return null;
  return <RebecaMiguelChatbot variant="floating" />;
}
